import {
    ADD_SHOW_FAVOURITE,
    REMOVE_SHOW_FAVOURITE,
    ADD_EPISODE_FAVOURITE,
    REMOVE_EPISODE_FAVOURITE,
    CLEAR_FAVOURITES,
} from '../actions/favourite';

const initialState = {
    shows: [],
    episodes: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_SHOW_FAVOURITE:
            return {
                ...state,
                shows: state.shows
                    ? [...state.shows, action.payload]
                    : [action.payload],
            };
        case REMOVE_SHOW_FAVOURITE:
            return {
                ...state,
                shows: state.shows
                    ? state.shows.filter(item => item.id !== action.payload.id)
                    : [],
            };

        case ADD_EPISODE_FAVOURITE:
            return {
                ...state,
                episodes: state.episodes
                    ? [...state.episodes, action.payload]
                    : [action.payload],
            };

        case REMOVE_EPISODE_FAVOURITE:
            return {
                ...state,
                episodes: state.episodes
                    ? state.episodes.filter(
                          item => item.id !== action.payload.id,
                      )
                    : [],
            };

        case CLEAR_FAVOURITES:
            return initialState;

        default:
            return state;
    }
};
